export class ShowContact {
    init()
    {
        $(".show-items").hide();
        $(".show-btn").on("click", function(e) {
            e.preventDefault(); // in some browsers a button submits if no type=
            $(this).hide()
            $(this).siblings(".show-items").show();
        });
    }
}
